module.exports = __webpack_public_path__ + "static/media/iceberg-transition-section-mobile.c0effe88.svg";